import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: 600 auto-generated "city x silver modifier" spun pages.
// The real silver pages live at /silver-rate-pakistan, /silver-rate-india
// and /silver-rate-{city} and are unaffected.
export const Route = createFileRoute("/silver-rate/$")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
